/* Bike-Alarm (snippets/cb-bike-alarm-form.liquid, -drawer.liquid, sections/cb-bike-alarm.liquid)
   Baut aus der Auswahl den Suchauftrag (JSON v2) und schickt ihn per fetch an api.cleverbikes.de/bike-alarm/anmelden
   (seit 19.10.2026; nicht mehr über Shopifys Kontaktformular, das zwingend hCaptcha verlangt). Bestätigen/Abmelden über
   /bike-alarm/aktion. Erfolg wird nur angezeigt, wenn der Server {ok:true} meldet (Bestätigungsmail ist raus).
   v2: {v:2, n:Name, k:[Kategorie], m:[Marke], kg:cm, p:Preis bis, pa:Preis ab, rf:[Rahmenform], g:[Rahmengröße],
        mo:[Motor], nm:Nm ab, wh:Wh ab, km:km bis, ez:Erstzulassung ab, s:Filiale, c:Kollektion}
   Server: shop-automation/bike-alarm (api.py, bikealarm.py) wertet genau dieses Format aus. */
(function () {
  if (window.cbBikeAlarm) return;
  window.cbBikeAlarm = true;

  var F = 'filter.p.m.';
  var PARAM = {
    k: F + 'custom.filter_kategorie', m: F + 'custom.filter_marke', kg: F + 'cb_size.koerpergroesse_stufen',
    rf: F + 'custom.filter_rahmenform', g: F + 'custom.filter_groesse', mo: F + 'custom.filter_motor',
    nm: F + 'custom.filter_drehmoment_nm', wh: F + 'global.akkukapazit_t', km: F + 'custom.filter_km_stufen',
    ez: F + 'custom.filter_erstzulassung', s: F + 'global.standort', p: 'filter.v.price.lte', pa: 'filter.v.price.gte'
  };
  var MULTI = ['k', 'rf', 'g', 'mo'];
  var NUM = ['kg', 'p', 'nm', 'wh', 'km', 'ez', 's'];
  var API = 'https://api.cleverbikes.de';
  var NICHT_ERREICHBAR = 'Der Bike-Alarm ist gerade nicht erreichbar. Bitte versuche es in ein paar Minuten noch einmal oder schreib uns an kontakt@cleverbikes.de.';
  /* Erste Zahl aus einem Filterwert: „7999.00“ (Preis, Punkt = Dezimal) → 7999, „bis 2.500 km“ (Tausenderpunkt) → 2500, „625 Wh“ → 625.
     Früher wurden alle Nicht-Ziffern entfernt, dann wurde aus 7999.00 → 799900 (Preis mal 100). */
  function zahl(v) {
    var m = String(v == null ? '' : v).match(/\d[\d.,]*/);
    if (!m) return null;
    var t = m[0].replace(/[.,]$/, '');
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(t)) t = t.replace(/\./g, '').replace(',', '.');
    else t = t.replace(',', '.');
    var n = Math.round(parseFloat(t));
    return isNaN(n) ? null : n;
  }
  function euro(n) { return n.toLocaleString('de-DE') + ' €'; }
  function tausend(n) { return n.toLocaleString('de-DE'); }

  /* ── Auftrag aus der Adresse (Shop-Filter) lesen ── */
  function ausAdresse(q, kollektion) {
    function all(name) { return q.getAll(name).map(function (v) { return v.trim(); }).filter(Boolean); }
    var a = {};
    var k = all(PARAM.k).concat(all('kategorie')); if (k.length) a.k = k;
    var m = all(PARAM.m).concat(all('marke')); if (m.length) a.m = m;
    ['rf', 'g', 'mo'].forEach(function (x) { var v = all(PARAM[x]); if (v.length) a[x] = v; });
    var kg = zahl(q.get('kg') || '');
    if (!kg) { var st = all(PARAM.kg).map(zahl).filter(Boolean); if (st.length) kg = Math.min.apply(null, st); }
    if (kg) a.kg = kg;
    var p = zahl(q.get('preis_bis') || q.get(PARAM.p) || ''); if (p) a.p = p;
    var pa = zahl(q.get(PARAM.pa) || ''); if (pa) a.pa = pa;
    var nm = all(PARAM.nm).map(zahl).filter(Boolean); if (nm.length) a.nm = Math.min.apply(null, nm);
    var wh = all(PARAM.wh).map(zahl).filter(Boolean); if (wh.length) a.wh = Math.min.apply(null, wh);
    var km = all(PARAM.km).map(zahl).filter(Boolean); if (km.length) a.km = Math.max.apply(null, km);
    var ez = all(PARAM.ez).map(zahl).filter(Boolean); if (ez.length) a.ez = Math.min.apply(null, ez);
    var s = q.get('standort') || all(PARAM.s)[0];
    if (s && !/^transporter/i.test(s)) a.s = s.replace('(E-Bike)', '(E-Bikes)');
    var c = (q.get('c') || (kollektion && kollektion.handle) || '').replace(/[^a-z0-9-]/g, '');
    if (c && c !== 'all') { a.c = c; a.cn = q.get('cn') || (kollektion && kollektion.name) || c; }
    return a;
  }

  /* ── Ein Formular ── */
  function Formular(form, modus) {
    this.form = form;
    this.modus = modus;
    this.marken = [];
    this.c = null;
    this.nameGeaendert = false;
    var self = this;
    this.$ = function (sel) { return form.querySelector(sel); };

    form.querySelectorAll('[data-ba-multi] input, [data-ba-num]').forEach(function (el) {
      el.addEventListener('change', function () { self.render(); });
      el.addEventListener('input', function () { self.render(); });
    });
    var tagIn = this.$('[data-ba-tag-input]');
    var addMarke = function () { self.addMarke(tagIn.value); tagIn.value = ''; };
    this.$('[data-ba-tag-add]').addEventListener('click', function () { addMarke(); tagIn.focus(); });
    tagIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addMarke(); } });
    tagIn.addEventListener('change', function () {
      var opts = document.getElementById(tagIn.getAttribute('list')).options, v = tagIn.value.trim();
      for (var i = 0; i < opts.length; i++) if (opts[i].value === v) { addMarke(); break; }
    });
    var toggle = this.$('[data-ba-toggle]');
    toggle.addEventListener('click', function () {
      var ed = self.$('[data-ba-editor]'), auf = ed.hidden;
      ed.hidden = !auf;
      toggle.setAttribute('aria-expanded', auf ? 'true' : 'false');
      self.$('[data-ba-toggle-text]').textContent = auf ? 'Kriterien schließen' : 'Kriterien bearbeiten';
    });
    this.$('[data-ba-name]').addEventListener('input', function () { self.nameGeaendert = true; });
    form.addEventListener('submit', function (e) { self.absenden(e); });
  }

  Formular.prototype.ansicht = function (v) {
    this.form.querySelectorAll('[data-ba-view]').forEach(function (el) { el.hidden = el.getAttribute('data-ba-view') !== v; });
  };

  Formular.prototype.setzen = function (a) {
    var f = this.form, self = this;
    MULTI.forEach(function (x) {
      f.querySelectorAll('[data-ba-multi="' + x + '"] input').forEach(function (cb) {
        cb.checked = !!(a[x] && a[x].some(function (v) { return v.toLowerCase() === cb.value.toLowerCase(); }));
      });
    });
    NUM.forEach(function (x) {
      var el = f.querySelector('[data-ba-num="' + x + '"]');
      if (!el) return;
      var v = a[x] == null ? '' : String(a[x]);
      if (el.tagName === 'SELECT' && v && !Array.prototype.some.call(el.options, function (o) { return o.value === v; })) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = x === 'nm' ? v + ' Nm' : x === 'wh' ? v + ' Wh' : x === 'km' ? tausend(+v) + ' km' : v;
        el.appendChild(o);
      }
      el.value = v;
    });
    this.marken = (a.m || []).slice(0, 10);
    this.pa = a.pa || null;
    this.c = a.c ? { handle: a.c, name: a.cn || a.c } : null;
    this.nameGeaendert = false;
    this.$('[data-ba-name]').value = '';
    this.render();
    void self;
  };

  Formular.prototype.addMarke = function (m) {
    m = (m || '').trim();
    if (!m || this.marken.length >= 10 || this.marken.some(function (x) { return x.toLowerCase() === m.toLowerCase(); })) return;
    this.marken.push(m);
    this.render();
  };

  Formular.prototype.auftrag = function () {
    var f = this.form, a = { v: 2 };
    MULTI.forEach(function (x) {
      var v = [];
      f.querySelectorAll('[data-ba-multi="' + x + '"] input:checked').forEach(function (cb) { v.push(cb.value); });
      if (v.length) a[x] = v;
    });
    if (this.marken.length) a.m = this.marken.slice();
    NUM.forEach(function (x) {
      var el = f.querySelector('[data-ba-num="' + x + '"]');
      if (!el || el.value === '') return;
      if (x === 's') { a.s = el.value; return; }
      var n = zahl(el.value);
      if (n) a[x] = n;
    });
    if (a.kg && (a.kg < 140 || a.kg > 215)) delete a.kg;
    if (this.pa) a.pa = this.pa;
    if (this.c) a.c = this.c.handle;
    return a;
  };

  /* Kriterien als lesbare Teile; je Teil eine Funktion zum Entfernen */
  Formular.prototype.teile = function (a) {
    var self = this, f = this.form, t = [];
    function weg(fn) { return function () { fn(); self.render(); }; }
    function multiAus(x, wert) {
      return weg(function () {
        f.querySelectorAll('[data-ba-multi="' + x + '"] input').forEach(function (cb) { if (cb.value === wert) cb.checked = false; });
      });
    }
    function numAus(x) { return weg(function () { f.querySelector('[data-ba-num="' + x + '"]').value = ''; }); }
    if (this.c) t.push({ text: this.c.name, aus: weg(function () { self.c = null; }) });
    (a.k || []).forEach(function (v) { t.push({ text: v, aus: multiAus('k', v) }); });
    (a.m || []).forEach(function (v, i) { t.push({ text: v, aus: weg(function () { self.marken.splice(i, 1); }) }); });
    if (a.kg) t.push({ text: a.kg + ' cm Körpergröße', aus: numAus('kg') });
    (a.g || []).length && t.push({ text: 'Rahmen ' + a.g.join('/'), aus: weg(function () { f.querySelectorAll('[data-ba-multi="g"] input').forEach(function (cb) { cb.checked = false; }); }) });
    (a.rf || []).forEach(function (v) { t.push({ text: v, aus: multiAus('rf', v) }); });
    if (a.pa) t.push({ text: 'ab ' + euro(a.pa), aus: weg(function () { self.pa = null; }) });
    if (a.p) t.push({ text: 'bis ' + euro(a.p), aus: numAus('p') });
    (a.mo || []).forEach(function (v) { t.push({ text: 'Motor ' + v, aus: multiAus('mo', v) }); });
    if (a.nm) t.push({ text: 'ab ' + a.nm + ' Nm', aus: numAus('nm') });
    if (a.wh) t.push({ text: 'Akku ab ' + a.wh + ' Wh', aus: numAus('wh') });
    if (a.km) t.push({ text: 'bis ' + tausend(a.km) + ' km', aus: numAus('km') });
    if (a.ez) t.push({ text: 'EZ ab ' + a.ez, aus: numAus('ez') });
    if (a.s) t.push({ text: a.s.replace('Store ', 'Filiale '), aus: numAus('s') });
    return t;
  };

  Formular.prototype.vorschlagName = function (a) {
    var basis = (this.c && this.c.name) || (a.k && a.k[0]) || (a.mo && 'E-Bike mit ' + a.mo[0]) || 'Mein Bike-Alarm';
    var z = [basis];
    if (a.m && a.m.length) z.push(a.m.slice(0, 2).join(' / '));
    if (a.p) z.push('bis ' + euro(a.p));
    return z.join(' · ').slice(0, 60);
  };

  Formular.prototype.render = function () {
    var a = this.auftrag(), t = this.teile(a), box = this.$('[data-ba-summary-chips]');
    box.innerHTML = '';
    if (!t.length) {
      var p = document.createElement('p');
      p.className = 'cb-ba-summary__leer';
      p.textContent = 'Noch keine Kriterien: Wir würden dir jedes neue Rad melden. Wähle unten aus, was dir wichtig ist.';
      box.appendChild(p);
    }
    t.forEach(function (x) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cb-ba-pill';
      b.setAttribute('aria-label', x.text + ' entfernen');
      b.innerHTML = '<span></span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      b.firstChild.textContent = x.text;
      b.addEventListener('click', x.aus);
      box.appendChild(b);
    });
    var tags = this.$('[data-ba-tags]'), self = this;
    tags.innerHTML = '';
    this.marken.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cb-ba-pill';
      b.innerHTML = '<span></span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      b.firstChild.textContent = m;
      b.addEventListener('click', function () { self.marken.splice(i, 1); self.render(); });
      tags.appendChild(b);
    });
    var name = this.$('[data-ba-name]');
    if (!this.nameGeaendert) name.placeholder = this.vorschlagName(a);
  };

  Formular.prototype.fehler = function (text, el) {
    var msg = this.$('[data-ba-msg]');
    msg.textContent = text;
    msg.hidden = false;
    if (el) el.focus();
  };

  Formular.prototype.absenden = function (e) {
    var f = this.form, aktion = this.$('[data-ba-aktion]').value;
    e.preventDefault();   /* nie normal abschicken: das Formular hat kein Ziel bei Shopify */
    if (aktion !== 'anmelden') return this.aktionSenden(aktion, e.submitter);
    if (this.laeuft) return;
    this.$('[data-ba-msg]').hidden = true;
    var email = this.$('[data-ba-email]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { return this.fehler('Bitte gib eine gültige E-Mail-Adresse ein.', email); }
    var consent = this.$('[data-ba-consent]');
    if (!consent.checked) { return this.fehler('Bitte bestätige, dass wir dir die Bike-Alarm-Mails schicken dürfen.', consent); }
    var tagIn = this.$('[data-ba-tag-input]');
    if (tagIn.value.trim()) { this.addMarke(tagIn.value); tagIn.value = ''; }

    var a = this.auftrag();
    if (a.p && a.p > 20000) {   /* Tippfehler wie 257000 statt 2570 abfangen */
      var ed = this.$('[data-ba-editor]');
      if (ed.hidden) this.$('[data-ba-toggle]').click();
      return this.fehler('Bitte prüfe deinen Preis: Unsere Räder kosten bis etwa 10.000 €. Gib den Betrag ohne Cent ein, z. B. 2500.', f.querySelector('[data-ba-num="p"]'));
    }
    a.n = (this.$('[data-ba-name]').value.trim() || this.vorschlagName(a)).slice(0, 60);
    if (!window.fetch) return this.fehler(NICHT_ERREICHBAR);

    var self = this, btn = this.$('[data-ba-submit]');
    this.laeuft = true;
    btn.disabled = true;
    btn.classList.add('is-laedt');
    fetch(API + '/bike-alarm/anmelden', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email.value.trim(), vorname: this.$('[data-ba-vorname]').value.trim(), auftrag: a,
        einwilligung: true, seite: location.pathname, website: this.$('[data-ba-hp]').value
      })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d && d.ok === true) {   /* nur dann ist die Bestätigungsmail wirklich raus */
          self.ansicht('erfolg');
          try { (self.form.closest('[data-cb-ba-seite]') || self.form).scrollIntoView({ block: 'start' }); } catch (x) {}
          return;
        }
        self.fehler((d && d.fehler) || NICHT_ERREICHBAR);
      })
      .catch(function () { self.fehler(NICHT_ERREICHBAR); })
      .then(function () { self.laeuft = false; btn.disabled = false; btn.classList.remove('is-laedt'); });
  };

  Formular.prototype.aktionSenden = function (aktion, btn) {
    var self = this;
    if (!window.fetch) return this.fehlerSeite(NICHT_ERREICHBAR);
    if (btn) { btn.disabled = true; btn.classList.add('is-laedt'); }
    fetch(API + '/bike-alarm/aktion', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ aktion: aktion, t: this.$('[data-ba-token]').value })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (x) {
        if (x.status === 200 && x.d.ok) return self.erfolg(aktion);
        if (x.status === 404) {
          return self.fehlerSeite(aktion === 'bestaetigen'
            ? 'Dieser Link ist abgelaufen oder der Bike-Alarm wurde schon beendet. Leg einfach einen neuen an.'
            : 'Dieser Link ist ungültig oder abgelaufen. Antworte einfach mit „Abmelden“ auf unsere E-Mail, dann tragen wir dich aus.');
        }
        throw new Error('Server');
      })
      .catch(function () { self.fehlerSeite(NICHT_ERREICHBAR); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-laedt'); } });
  };

  Formular.prototype.erfolg = function (akt) {
    this.ansicht('erfolg');
    if (akt === 'bestaetigen') {
      this.$('[data-ba-erfolg-title]').textContent = 'Danke! Dein Bike-Alarm ist aktiv.';
      this.$('[data-ba-erfolg-text]').textContent = 'In den nächsten Minuten bekommst du eine E-Mail mit den Rädern, die schon jetzt passen. Danach melden wir uns, sobald ein neues passendes Rad online ist.';
    } else if (akt === 'abmelden' || akt === 'abmelden_alle') {
      this.$('[data-ba-erfolg-title]').textContent = 'Erledigt.';
      this.$('[data-ba-erfolg-text]').textContent = akt === 'abmelden_alle'
        ? 'Alle deine Bike-Alarme sind beendet. Du bekommst keine Bike-Alarm-Mails mehr.'
        : 'Dieser Bike-Alarm ist beendet. Du bekommst dafür keine E-Mails mehr.';
    }
    try { this.form.closest('[data-cb-ba-seite]').scrollIntoView({ block: 'start' }); } catch (e) {}
  };

  Formular.prototype.fehlerSeite = function (text) {
    this.ansicht('erfolg');
    var icon = this.form.querySelector('[data-ba-view="erfolg"] .cb-ba-state__icon');
    if (icon) icon.style.display = 'none';
    this.$('[data-ba-erfolg-title]').textContent = 'Das hat nicht geklappt';
    this.$('[data-ba-erfolg-text]').textContent = text;
  };

  /* ── Seitliches Fenster ── */
  var drawer = document.getElementById('cb-ba-drawer'), df = null, zuletzt = null;
  if (drawer) {
    df = new Formular(drawer.querySelector('[data-cb-ba-form]'), 'drawer');
    var kol = drawer.dataset.kollektion ? { handle: drawer.dataset.kollektion, name: drawer.dataset.kollektionName } : null;
    var oeffnen = function (ansicht) {
      zuletzt = document.activeElement;
      if (ansicht !== 'erfolg') { df.setzen(ausAdresse(new URLSearchParams(location.search), kol)); df.ansicht('anmelden'); }
      else df.ansicht('erfolg');
      drawer.hidden = false;
      document.documentElement.classList.add('cb-ba-offen');
      requestAnimationFrame(function () { drawer.classList.add('is-offen'); });
      setTimeout(function () { var x = drawer.querySelector('.cb-ba-drawer__close'); if (x) x.focus(); }, 60);
    };
    var schliessen = function () {
      drawer.classList.remove('is-offen');
      document.documentElement.classList.remove('cb-ba-offen');
      setTimeout(function () { drawer.hidden = true; }, 260);
      if (zuletzt && zuletzt.focus) zuletzt.focus();
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cb-ba-open]')) { e.preventDefault(); oeffnen(); }
      else if (e.target.closest('[data-cb-ba-close]')) schliessen();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) schliessen(); });
    window.cbBikeAlarmOeffnen = oeffnen;
  }

  /* ── Seite /pages/bike-alarm ── */
  var seite = document.querySelector('[data-cb-ba-seite] [data-cb-ba-form]');
  if (seite) {
    var sf = new Formular(seite, 'seite'), q = new URLSearchParams(location.search);
    if (q.get('bestaetigen') || q.get('abmelden')) {
      var tok = (q.get('bestaetigen') || q.get('abmelden')).replace(/[^A-Za-z0-9_-]/g, '').slice(0, 64);
      sf.$('[data-ba-token]').value = tok;
      if (q.get('bestaetigen')) { sf.$('[data-ba-aktion]').value = 'bestaetigen'; sf.ansicht('bestaetigen'); }
      else {
        var alle = q.get('alle') === '1';
        sf.$('[data-ba-aktion]').value = alle ? 'abmelden_alle' : 'abmelden';
        if (alle) {
          sf.$('[data-ba-abmelden-title]').textContent = 'Alle Bike-Alarme beenden?';
          sf.$('[data-ba-abmelden-text]').textContent = 'Danach bekommst du von uns keine Bike-Alarm-Mails mehr, für keinen deiner Suchaufträge.';
        }
        sf.ansicht('abmelden');
      }
      try { seite.closest('[data-cb-ba-seite]').scrollIntoView({ block: 'start' }); } catch (e) {}
    } else {
      sf.setzen(ausAdresse(q, null));
      sf.ansicht('anmelden');
    }
  }
})();
